import styled from 'styled-components';

export const Container = styled.div<{ $isBlankBackground?: boolean; $isMobile?: boolean }>`
  /* не перекрывать раскрытое меню другой сигареты */
  & > form {
    z-index: auto;
  }

  & > form div.lt-departure-picker__control {
    border-radius: 0;
  }

  ${({ $isBlankBackground }) =>
    !$isBlankBackground &&
    `
    background: #4d4d4d;
    border-radius: 4px;
    max-width: 1200px;
    padding: 8px;
    margin: auto;
  `}

  ${({ $isMobile }) =>
    $isMobile
      ? `
        & > form {
          background-color: #4d4d4d;
        }
      `
      : `
        & > form > div:last-child {
          padding: 9px 8px;
        }
      `}
`;
